export interface StateToValuePostalCodeFormatterOptions {
  options?: {
    forceSeparator?: boolean;
  };
}

const stateToValuePostalCodeFormatter = (value: string, { options: { forceSeparator } = {} }: StateToValuePostalCodeFormatterOptions = {}) => {
  if (!value) {
    return '';
  }

  const matches = value.match(/^([a-z0-9]{0,3})([- _]*)([a-z0-9]{0,3})$/i);

  if (matches) {
    // eslint-disable-next-line prefer-const
    let [, c1, s2, c2] = matches;

    if (forceSeparator || (c1 && !s2 && c2)) {
      s2 = ' ';
    }

    return [c1, s2, c2].join('').toUpperCase();
  }

  return value.toUpperCase();
};

export default stateToValuePostalCodeFormatter;
